import { InjectedStyledComponent } from '../InjectedStyledComponent';

const cssPrefix = `
	position: absolute;
`;

export default InjectedStyledComponent('div', 'shared', ['dropdownMenu'], ['appStore'], cssPrefix);